import React from "react";
import { useNavigate } from "react-router-dom"; // ✅ React Router hook
import Navbar from "./Navbar";
import Footer from "./Footer";
import "../styles/Z1.css";

// ⭐ Example rows data – replace with your images, headings & text
import abc from "../assets/images/0itm101.webp";
import abc1 from "../assets/images/0itm102.webp";
import abc2 from "../assets/images/0itm103.webp";
import abc3 from "../assets/images/0itm104.webp";
import abc4 from "../assets/images/0itm105.webp";
import abc5 from "../assets/images/0itm106.webp";
import abc6 from "../assets/images/0itm107.webp";
import abc7 from "../assets/images/0itm108.webp";
import abc8 from "../assets/images/0itm109.webp"
import img10 from "../assets/images/0itm110.webp";
import img11 from "../assets/images/0itm111.webp";
import img12 from "../assets/images/0itm112.webp";

const rowsData = [
  { id: 1, title: "HVAC And MEP", text: "HVAC and MEP solutions for efficient heating, cooling, ventilation, and building services systems.", img: abc, gradient: "gradient1", link: "/Z1" },
  { id: 2, title: "AC Tools & Accessories", text: "High-quality AC tools and accessories for installation, maintenance, and repair of air conditioning systems.", img: abc1, gradient: "gradient2", link: "/Z2" },
  { id: 3, title: "Electrical Items", text: "Reliable electrical components for industrial and commercial applications.", img: abc2, gradient: "gradient3", link: "/Z3" },
  { id: 4, title: "Hydraulic Lubricant", text: "High-performance hydraulic lubricants to ensure smooth machinery operation.", img: abc3, gradient: "gradient4", link: "/Z4" },
  { id: 5, title: "Pneumatics", text: "Quality pneumatic components for efficient automation and control systems.", img: abc4, gradient: "gradient5", link: "/Z5" },
  { id: 6, title: "Mechanical Parts", text: "Durable mechanical parts for all types of industrial machinery.", img: abc5, gradient: "gradient1", link: "/Z6" },
  { id: 7, title: "Pipes, Valves & Fittings", text: "Precision-engineered pipes, valves, and fittings for secure fluid flow.", img: abc6, gradient: "gradient2", link: "/Z7" },
  { id: 8, title: "Air Compressor & Spare Parts", text: "Efficient air compressors and genuine spare parts for long-lasting performance.", img: abc7, gradient: "gradient3", link: "/Z8" },
  { id: 9, title: "Mechanical Spare Parts", text: "Genuine spare parts for maintaining and repairing mechanical systems.", img: abc8, gradient: "gradient4", link: "/Z9" },
  { id: 10, title: "Safety & PPE'S", text: "Protective gear and personal safety equipment for workplace safety compliance.", img: img10, gradient: "gradient5", link: "/Z10" },
  { id: 11, title: "Tools And Accessories", text: "Essential tools and accessories for industrial maintenance and repair.", img: img11, gradient: "gradient1", link: "/Z11" },
  { id: 12, title: "Electronic Repairs", text: "Reliable electronic repair services and components for smooth operations.", img: img12, gradient: "gradient2", link: "/Z12" }
];

function Navitm() {
  const navigate = useNavigate(); // ✅ Hook for navigation

  return (
    <>
      <Navbar />

      <section className="z1-section">
        {rowsData.map((row) => (
          <div
            key={row.id}
            className={`z1-row ${row.gradient}`}
          >
            <div className="z1-img">
              <img src={row.img} alt={row.title} />
            </div>

            <div className="z1-content">
              <h2>{row.title}</h2>
              <p>{row.text}</p>

              {/* ✅ See More Button */}
              <button
                className="see-more-btn"
                onClick={() => navigate(row.link)}
              >
                See More
              </button>
            </div>
          </div>
        ))}
      </section>

      <Footer />
    </>
  );
}

export default Navitm;
